import { useState, useEffect } from 'react';
import { apiClient, ApiType } from '@shared/apiClient';

type DataObject = Record<string, string>;

interface props {
  token: string | undefined;
  url: string;
}

interface ReturnType {
  data: DataObject[] | undefined;
  isLoading: boolean;
  dataError: boolean;
}

export const useFormFieldData = ({ token, url }: props): ReturnType => {
  const [data, setData] = useState<DataObject[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataError, setDataError] = useState<boolean>(false);

  useEffect(() => {
    if (url) {
      try {
        setIsLoading(true);
        apiClient
          .get(ApiType.external, {
            url,
          })
          .then((res) => {
            setData(res.data);
            setIsLoading(false);
            setDataError(false);
          });
      } catch (e) {
        setIsLoading(false);
        setDataError(true);
      }
    }
  }, [url, token]);

  return { data, isLoading, dataError };
};
